/**
 * Discount Configuration
 * Central config for the site-wide discount system.
 */

// Feature flag - set false to hide Top Sellers and show BestSellers instead
export const TOP_SELLERS_ENABLED = true;

// Number of games to show in Top Sellers section
export const TOP_SELLERS_COUNT = 4;

// Auto-discount: 15% off when buying 3 or more games
export const AUTO_DISCOUNT_PERCENT = 15;
export const AUTO_DISCOUNT_MIN_GAMES = 3;
